import {
  IGNORE_SECURITY_ISSUE,
  LOAD_SECURITY_AUTOUPDATE,
  LOAD_SECURITY_AUTOUPDATE_FAIL,
  LOAD_SECURITY_AUTOUPDATE_SUCCESS,
  LOAD_SECURITY_IGNORED_ISSUES,
  LOAD_SECURITY_IGNORED_ISSUES_FAIL,
  LOAD_SECURITY_IGNORED_ISSUES_SUCCESS,
  LOAD_SECURITY_SCAN,
  LOAD_SECURITY_SCAN_FAIL,
  LOAD_SECURITY_SCAN_SUCCESS,
  LOAD_SECURITY_SCHEDULE,
  LOAD_SECURITY_SCHEDULE_FAIL,
  LOAD_SECURITY_SCHEDULE_SUCCESS,
  LOAD_SECURITY_SETTINGS,
  LOAD_SECURITY_SETTINGS_FAIL,
  LOAD_SECURITY_SETTINGS_SUCCESS,
  LoadSecurityAutoupdate,
  LoadSecurityAutoupdateFail,
  LoadSecurityAutoupdateSuccess,
  LoadSecurityIgnoredIssues,
  LoadSecurityIgnoredIssuesFail,
  LoadSecurityIgnoredIssuesSuccess,
  LoadSecurityScanFail,
  LoadSecurityScanSuccess,
  LoadSecuritySchedule,
  LoadSecurityScheduleFail,
  LoadSecurityScheduleSuccess,
  LoadSecuritySettings,
  LoadSecuritySettingsFail,
  LoadSecuritySettingsSuccess,
  RESTORE_SECURITY_FILE,
  RESTORE_SECURITY_ISSUE,
  RUN_SECURITY_SCAN,
  RUN_SECURITY_SCAN_FAIL,
  RUN_SECURITY_SCAN_SUCCESS,
  RunSecurityScan,
  RunSecurityScanFail,
  RunSecurityScanSuccess,
  SecurityAction,
  UPDATE_SECURITY_AUTOUPDATE,
  UPDATE_SECURITY_AUTOUPDATE_FAIL,
  UPDATE_SECURITY_AUTOUPDATE_SUCCESS,
  UPDATE_SECURITY_SCHEDULE,
  UPDATE_SECURITY_SCHEDULE_FAIL,
  UPDATE_SECURITY_SCHEDULE_SUCCESS,
  UPDATE_SECURITY_SETTINGS,
  UPDATE_SECURITY_SETTINGS_FAIL,
  UPDATE_SECURITY_SETTINGS_SUCCESS,
  UpdateSecurityAutoupdate,
  UpdateSecurityAutoupdateFail,
  UpdateSecurityAutoupdateSuccess,
  UpdateSecuritySchedule,
  UpdateSecurityScheduleFail,
  UpdateSecurityScheduleSuccess,
  UpdateSecuritySettingsFail,
  UpdateSecuritySettingsSuccess
} from '../actions';
import {LoadSecurityScan} from "../actions/security.action";

export interface IWebsiteSecurityScanState {
  securityScan: any;
  running: boolean;
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteSecurityIgnoredIssuesState {
  securityIgnoredIssues: any;
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteSecuritySettingsState {
  securitySettings: any;
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteSecurityScheduleState {
  securitySchedule: any;
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteSecurityAutoupdateState {
  securityAutoupdate: any;
  loading: boolean;
  loaded: boolean;
}

export interface IWebsiteSecurityState {
  securityScan: IWebsiteSecurityScanState;
  securityIgnoredIssues: IWebsiteSecurityIgnoredIssuesState;
  securitySettings: IWebsiteSecuritySettingsState;
  securitySchedule: IWebsiteSecurityScheduleState;
  securityAutoupdate: IWebsiteSecurityAutoupdateState;
}

export interface ISecurityState {
  entities: {[websiteId: number]: IWebsiteSecurityState};
}

export const initialState: ISecurityState = {
  entities: {}
};

export function reducer(state: ISecurityState = initialState, action: SecurityAction): ISecurityState {
  let payload: any;
  let websiteSecurityState: IWebsiteSecurityState;

  switch (action.type) {

    case RUN_SECURITY_SCAN:
      payload = (<RunSecurityScan>action).payload;

      websiteSecurityState = state.entities[payload] || getInitialWebsiteSecurityState();

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...websiteSecurityState,
            securityScan: {
              ...websiteSecurityState.securityScan,
              running: true
            }
          }
        }
      };

    case RUN_SECURITY_SCAN_SUCCESS:
      payload = (<RunSecurityScanSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityScan: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityScan : <IWebsiteSecurityScanState>{}),
              running: false
            }
          }
        }
      };

    case RUN_SECURITY_SCAN_FAIL:
      payload = (<RunSecurityScanFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityScan: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityScan : <IWebsiteSecurityScanState>{}),
              running: false
            }
          }
        }
      };

    case LOAD_SECURITY_SCAN:
      payload = (<LoadSecurityScan>action).payload;

      websiteSecurityState = state.entities[payload] || getInitialWebsiteSecurityState();

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...websiteSecurityState,
            securityScan: {
              ...websiteSecurityState.securityScan,
              loading: true,
              loaded: false
            }
          }
        }
      };

    case LOAD_SECURITY_SCAN_SUCCESS:
      payload = (<LoadSecurityScanSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityScan: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityScan : <IWebsiteSecurityScanState>{}),
              securityScan: payload.securityScan,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_SCAN_FAIL:
      payload = (<LoadSecurityScanFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityScan: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityScan : <IWebsiteSecurityScanState>{}),
              securityScan: null,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_IGNORED_ISSUES:
      payload = (<LoadSecurityIgnoredIssues>action).payload;

      websiteSecurityState = state.entities[payload] || getInitialWebsiteSecurityState();

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...websiteSecurityState,
            securityIgnoredIssues: {
              ...websiteSecurityState.securityIgnoredIssues,
              loading: true,
              loaded: false
            }
          }
        }
      };

    case LOAD_SECURITY_IGNORED_ISSUES_SUCCESS:
      payload = (<LoadSecurityIgnoredIssuesSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityIgnoredIssues: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityIgnoredIssues : <IWebsiteSecurityIgnoredIssuesState>{}),
              securityIgnoredIssues: payload.securityIgnoredIssues,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_IGNORED_ISSUES_FAIL:
      payload = (<LoadSecurityIgnoredIssuesFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityIgnoredIssues: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityIgnoredIssues : <IWebsiteSecurityIgnoredIssuesState>{}),
              securityIgnoredIssues: null,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case IGNORE_SECURITY_ISSUE:
      return state;

    case RESTORE_SECURITY_ISSUE:
      return state;

    case RESTORE_SECURITY_FILE:
      return state;

    case LOAD_SECURITY_SETTINGS:
      payload = (<LoadSecuritySettings>action).payload;

      websiteSecurityState = state.entities[payload] || getInitialWebsiteSecurityState();

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...websiteSecurityState,
            securitySettings: {
              ...websiteSecurityState.securitySettings,
              loading: true,
              loaded: false
            }
          }
        }
      };

    case LOAD_SECURITY_SETTINGS_SUCCESS:
      payload = (<LoadSecuritySettingsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySettings: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySettings : <IWebsiteSecuritySettingsState>{}),
              securitySettings: payload.securitySettings,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_SETTINGS_FAIL:
      payload = (<LoadSecuritySettingsFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySettings: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySettings : <IWebsiteSecuritySettingsState>{}),
              securitySettings: null,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case UPDATE_SECURITY_SETTINGS:
      return state;


    case UPDATE_SECURITY_SETTINGS_SUCCESS:
      payload = (<UpdateSecuritySettingsSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySettings: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySettings : <IWebsiteSecuritySettingsState>{}),
              securitySettings: payload.securitySettings,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case UPDATE_SECURITY_SETTINGS_FAIL:
      payload = (<UpdateSecuritySettingsFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySettings: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySettings : <IWebsiteSecuritySettingsState>{}),
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_SCHEDULE:
      payload = (<LoadSecuritySchedule>action).payload;

      websiteSecurityState = state.entities[payload] || getInitialWebsiteSecurityState();

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...websiteSecurityState,
            securitySchedule: {
              ...websiteSecurityState.securitySchedule,
              loading: true,
              loaded: false
            }
          }
        }
      };

    case LOAD_SECURITY_SCHEDULE_SUCCESS:
      payload = (<LoadSecurityScheduleSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySchedule: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySchedule : <IWebsiteSecurityScheduleState>{}),
              securitySchedule: payload.securitySchedule,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_SCHEDULE_FAIL:
      payload = (<LoadSecurityScheduleFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySchedule: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySchedule : <IWebsiteSecurityScheduleState>{}),
              securitySchedule: null,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case UPDATE_SECURITY_SCHEDULE:
      payload = (<UpdateSecuritySchedule>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySchedule: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySchedule : <IWebsiteSecurityScheduleState>{}),
              securitySchedule: payload.securitySchedule,
              loading: true,
              loaded: false
            }
          }
        }
      };


    case UPDATE_SECURITY_SCHEDULE_SUCCESS:
      payload = (<UpdateSecurityScheduleSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySchedule: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySchedule : <IWebsiteSecurityScheduleState>{}),
              securitySchedule: payload.securitySchedule,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case UPDATE_SECURITY_SCHEDULE_FAIL:
      payload = (<UpdateSecurityScheduleFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securitySchedule: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySchedule : <IWebsiteSecurityScheduleState>{}),
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_AUTOUPDATE:
      payload = (<LoadSecurityAutoupdate>action).payload;

      websiteSecurityState = state.entities[payload] || getInitialWebsiteSecurityState();

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...websiteSecurityState,
            securityAutoupdate: {
              ...websiteSecurityState.securityAutoupdate,
              loading: true,
              loaded: false
            }
          }
        }
      };

    case LOAD_SECURITY_AUTOUPDATE_SUCCESS:
      payload = (<LoadSecurityAutoupdateSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityAutoupdate: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityAutoupdate : <IWebsiteSecurityAutoupdateState>{}),
              securityAutoupdate: payload.securityAutoupdate,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case LOAD_SECURITY_AUTOUPDATE_FAIL:
      payload = (<LoadSecurityAutoupdateFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityAutoupdate: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityAutoupdate : <IWebsiteSecurityAutoupdateState>{}),
              securityAutoupdate: null,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case UPDATE_SECURITY_AUTOUPDATE:
      payload = (<UpdateSecurityAutoupdate>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityAutoupdate: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityAutoupdate : <IWebsiteSecurityAutoupdateState>{}),
              securityAutoupdate: payload.securityAutoupdate,
              loading: true,
              loaded: false
            }
          }
        }
      };


    case UPDATE_SECURITY_AUTOUPDATE_SUCCESS:
      payload = (<UpdateSecurityAutoupdateSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityAutoupdate: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securitySchedule : <IWebsiteSecurityAutoupdateState>{}),
              securityAutoupdate: payload.securityAutoupdate,
              loading: false,
              loaded: true
            }
          }
        }
      };

    case UPDATE_SECURITY_AUTOUPDATE_FAIL:
      payload = (<UpdateSecurityAutoupdateFail>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            securityAutoupdate: {
              ...(state.entities[payload.websiteId] ? state.entities[payload.websiteId].securityAutoupdate : <IWebsiteSecurityAutoupdateState>{}),
              loading: false,
              loaded: true
            }
          }
        }
      };
  }

  return state;
}

function getInitialWebsiteSecurityState() {
  return {
    securityScan: {
      securityScan: null,
        running: false,
        loading: false,
        loaded: false
    },
    securityIgnoredIssues: {
      securityIgnoredIssues: null,
      loading: false,
      loaded: false
    },
    securitySettings: {
      securitySettings: null,
        loading: false,
        loaded: false
    },
    securitySchedule: {
      securitySchedule: null,
        loading: false,
        loaded: false
    },
    securityAutoupdate: {
      securityAutoupdate: null,
        loading: false,
        loaded: false
    }
  };
}
